import { useFeatureAccessInsights } from '../featureAccessInsights';

export const useIsLeadersInsightsEntryPointVisible = (): boolean => {
  const featureAccessInsights = useFeatureAccessInsights();

  return featureAccessInsights?.canViewLeadershipActivity === true;
};
